import { Card, CardContent, CardHeader, Link } from '@mui/material';
import { ElementType } from 'react';
import { WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { useNotificationStore } from '../../../utils/NotificationStore';
type props = {
  title: string;
  Logo: ElementType;
  href: string;
  isAdmin: boolean;
  description: string;
};

const AppsCard = ({ title, Logo, href, isAdmin, description }: props) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const element = (
    <>
      <CardHeader
        title={title}
        titleTypographyProps={{
          fontWeight: 700,
        }}
        avatar={<Logo />}
      />
      <CardContent sx={{ pl: 8, py: 0 }}>
        <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SECONDARY}>
          {description}
        </WsTypography>
      </CardContent>
    </>
  );

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 1.5,
      }}
    >
      {isAdmin && (
        <>
          <Link
            underline="none"
            onClick={() => window.open(`${href}`, '_blank')}
            sx={{ cursor: 'pointer' }}
          >
            {element}
          </Link>
        </>
      )}

      {!isAdmin && (
        <>
          <Link
            underline="none"
            onClick={() =>
              setNotification({
                type: 'warning',
                message: 'Access to this is limited to the Workspace Administrator only.',
              })
            }
          >
            {element}
          </Link>
        </>
      )}
    </Card>
  );
};

export default AppsCard;
